import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { LEAD_TYPES } from '../constants';
import CrmModal from './crmModal';
import { setGlobalError } from '../../../Redux/Reducer/GlobalError';

const SettingsModal = ({
  handleClose,
  configIntegration,
  tenantId,
  statusMappings,
  settingsInitailValue,
  assignToKelsey,
  tenantData,
  crmSetupInitial,
  pmsSetupInitial,
  initalStatusMapping
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [selectedCrmContact, setSelectedCrmContact] = useState([]);
  const [settingsName, setSettingsName] = useState(
    settingsInitailValue || 'Live Communities'
  );
  const [assignLeadToKelsey, setassignLeadToKelsey] = useState(assignToKelsey);
  const [crmData, setCrmData] = useState(initalStatusMapping);
  const [crmType, setCrmType] = useState([]);
  const [pmsSetup, setPmsSetup] = useState({
    propertyIngestion: pmsSetupInitial,
    leadIngestion: !crmSetupInitial && pmsSetupInitial,
    kelsyAssign: assignLeadToKelsey,
    selectedLeadType: []
  });
  const [crmSetup, setcrmSetup] = useState({
    propertyIngestion: crmSetupInitial || false,
    leadIngestion: crmSetupInitial || !pmsSetupInitial || false,
    kelsyAssign: assignLeadToKelsey,
    selectedLeadType: []
  });

  const settings = {
    source: 'knock',
    sourceType: 'CRM',
    mappings: crmData,
    allowedFirstContactTypes: []
  };

  const payload = {
    tenantId,
    settingsName,
    pmsSetup: true,
    crmSetup: false,
    propertyIngestion: !!pmsSetup?.propertyIngestion,
    leadIngestion: !!pmsSetup?.leadIngestion
  };

  const crmPayload = {
    tenantId,
    settingsName,
    pmsSetup: false,
    crmSetup: crmSetup.leadIngestion,
    propertyIngestion: !!pmsSetup?.propertyIngestion,
    leadIngestion: true,
    assignLeadToKelsey,
    crmSettings: {
      crm: 'knock',
      autoAssignLeadToKelsey: true
    },
    statusMappingsDefaultKnock: {
      ...settings,
      allowedFirstContactTypes: [...selectedCrmContact]
    }
  };

  const handlePmsChange = e => {
    const { name, checked } = e.target;
    if (crmSetup.leadIngestion && name === 'leadIngestion') {
      dispatch(setGlobalError('Please turn off lead ingestion on CRM level.'));
      return;
    }
    setPmsSetup(prev => ({ ...prev, [name]: checked }));
  };

  const handleCrmChange = e => {
    if (pmsSetup.leadIngestion) {
      dispatch(setGlobalError('Please turn off lead ingestion on PMS level'));
      return;
    }
    const { name, checked } = e.target;
    setcrmSetup(prev => ({ ...prev, [name]: checked }));
  };

  let z = [];

  const [allKelseyContact, setAllKelseyContact] = useState([
    { name: 'call', checked: false },
    { name: 'form', checked: true },
    { name: 'chat', checked: true },
    { name: 'internet', checked: true },
    { name: 'email', checked: true },
    { name: 'knock-schedule', checked: true },
    { name: 'facebook', checked: true },
    { name: 'sms', checked: true },
    { name: 'landline', checked: true },
    { name: 'walk-in', checked: false }
  ]);

  useEffect(() => {
    if (allKelseyContact) {
      allKelseyContact.map(x => {
        if (x.checked === true) {
          z.push(x.name);
        }
      });
    }
    if (tenantData?.statusMappings?.allowedFirstContactTypes) {
      let array1 = tenantData?.statusMappings?.allowedFirstContactTypes;
      let array2 = allKelseyContact;
      let newObj = [];
      array2.filter(val => {
        if (array1.includes(val.name)) {
          newObj.push({ name: val.name, checked: true });
        } else {
          newObj.push({ name: val.name, checked: false });
        }
      });
      setAllKelseyContact(newObj);
    }
  }, [tenantData]);

  const handleCrmType = (_, newValue) => {
    if (newValue && newValue.length > 0) {
      setCrmType(newValue);
      setSelectedCrmContact(newValue.map(item => item.value));
    } else {
      setCrmType([]);
      setSelectedCrmContact([]);
    }
  };

  const handleconfigIntegration = () => {
    dispatch(
      configIntegration({
        payload: crmSetup?.leadIngestion ? crmPayload : payload
      })
    );
    handleClose();
  };

  useEffect(() => {
    if (statusMappings?.allowedFirstContactTypes) {
      const allowedFirstContactTypes = statusMappings?.allowedFirstContactTypes;
      const data = allowedFirstContactTypes?.reduce(
        (acc, item) => {
          const accValue = [
            ...acc.accValue,
            { value: item?.value || item, label: item?.label || item }
          ];
          const payloadData = [...acc.payloadData, item?.value || item];
          return { accValue, payloadData };
        },
        { accValue: [], payloadData: [] }
      );
      setSelectedCrmContact(data.payloadData || []);
      setCrmType(data?.accValue || []);
    }
  }, [statusMappings]);

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      sx={{ '& .MuiDialog-paper': { maxHeight: '85vh' } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 500 }}>
          Configure new setting
        </Typography>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Tabs
          value={activeTab}
          onChange={(_, newVal) => setActiveTab(newVal)}
          sx={{ mb: 3 }}
        >
          <Tab label="PMS Setup" />
          <Tab label="CRM Setup" />
        </Tabs>

        {activeTab === 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  name="propertyIngestion"
                  checked={pmsSetup.propertyIngestion}
                  onChange={handlePmsChange}
                />
              }
              label="Property Ingestion"
              labelPlacement="start"
              sx={{ justifyContent: 'space-between', ml: 0 }}
            />
            <FormControlLabel
              control={
                <Switch
                  name="leadIngestion"
                  checked={pmsSetup.leadIngestion}
                  onChange={handlePmsChange}
                />
              }
              label="Lead Ingestion"
              labelPlacement="start"
              sx={{ justifyContent: 'space-between', ml: 0 }}
            />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  name="leadIngestion"
                  checked={crmSetup.leadIngestion}
                  onChange={handleCrmChange}
                />
              }
              label="Lead Ingestion"
              labelPlacement="start"
              sx={{ justifyContent: 'space-between', ml: 0 }}
            />
            {crmSetup?.leadIngestion && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2
                }}
              >
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Do you want to assign leads to Kelsey?
                  </Typography>
                  <RadioGroup
                    row
                    defaultValue={assignLeadToKelsey ? 'yes' : 'no'}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                      onClick={() => setassignLeadToKelsey(true)}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                      onClick={() => setassignLeadToKelsey(false)}
                    />
                  </RadioGroup>
                </Box>

                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Select lead type to connect *
                  </Typography>
                  <Autocomplete
                    multiple
                    options={LEAD_TYPES}
                    getOptionLabel={option => option.label}
                    isOptionEqualToValue={(option, val) =>
                      option.value === val.value
                    }
                    value={crmType}
                    onChange={handleCrmType}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          label={option.label}
                          size="small"
                          {...getTagProps({ index })}
                          key={option.value}
                        />
                      ))
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={
                          crmType.length === 0 ? 'Select lead types' : ''
                        }
                      />
                    )}
                  />
                </Box>

                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Configure lead status mapping
                  </Typography>
                  <CrmModal
                    tenantData={tenantData}
                    setCrmData={setCrmData}
                    autoAssignLeadToKelsey={tenantData.autoAssignLeadToKelsey}
                    allowedFirstContactTypes={z}
                  />
                </Box>
              </Box>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <Button onClick={handleClose} variant="text">
          Clear
        </Button>
        <Button onClick={handleconfigIntegration} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsModal;
